// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { NequiQrCode } from '../nequi-qr-code';

export function NequiInstructions(): Node {
  return(
    <Root>
      <NequiInstructionsTitle>
        Paga con NEQUI
      </NequiInstructionsTitle>

      <NequiInstructionsMessage>
        Abrí NEQUI en tu teléfono móvil y usa el siguiente código QR para pagar:
      </NequiInstructionsMessage>

      <NequiQrCode/>
    </Root>
  );
}

const Root = styled.div`
  @media (min-width: 450px) {
    width: 70%;
    margin: auto;
  }
`;

const NequiInstructionsMessage = styled.p``;

const NequiInstructionsTitle = styled.p`
  font-weight: bold;
  text-align: center;
  line-height: 1.3;
  margin-bottom: 20px;
`;
